import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeReport } from "../../../components/Reports";
import { FC } from "react";

export interface IEmployeeReportPage {}

export const EmployeeReportPage: FC<IEmployeeReportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Employess"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<EmployeeReport />}
    />
  );
};
